import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, Output, Injector } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Router } from '@angular/router';
import { RoutingDataService } from '../../../submodules/angular-common/routing-data.service';
import { SecurityDataService } from '../../../submodules/angular-common/security-data.service';
import { buildSelectableOptions } from '../forms/forms-util';
import { MenuNode } from '../base-types';
import { BaseView } from '../base-view';
import { CanvasLayoutDataService } from '../../angular-common/canvas-layout-data.service';
import { Color } from 'src/app/config/color';

/**
 * Modello interno. Uso esclusivamente privato
 */
class FlatNode {
  id: number | string;  // non serve al CDK. Serve solo al consumer per matchare gli elementi selezionati con il modello esterno
  label: string;        // viene visualizzata dalla view
  level: number;
  hasChildren: boolean;
  icon: string;
  hidden: boolean;
  disabled: boolean;
}

/**
 * @title Tree Menu
 */
@Component({
  selector: 'app-tree-menu',
  templateUrl: './tree-menu.component.html',
  styleUrls: ['./tree-menu.component.scss']
})
export class TreeMenuComponent extends BaseView {

  @Input() fontSize: string
  @Input() fontColor: string = Color.main;
  @Input() selectedItemFontColor: string = Color.light;
  @Input() hoverItemFontColor: string
  @Input() bgColor: string
  @Input() selectedItemBgColor: string = Color.auxiliary;
  @Input() hoverItemBgColor: string
  @Input() borderColor: string
  @Input() selectedItemBorderColor: string
  @Input() hoverItemBorderColor: string
  @Input() hoverItemBorderBottomColor: string
  @Input() selectedItemBorderBottomColor: string

  @Output() selectionChange: EventEmitter<(number|string)[]> = new EventEmitter<(number|string)[]>();

  public treeFlattener: MatTreeFlattener<MenuNode, FlatNode>;
  public dataSource: MatTreeFlatDataSource<MenuNode, FlatNode>;
  /**
   * Serve per gestire lo stato di expanded/collapsed dei nodi dell'albero
   */
  public treeControl: FlatTreeControl<FlatNode>;

  constructor(
    public routingDataService: RoutingDataService,
    protected _injector: Injector
  ) {
    super(_injector);

    // Tutti questi oggetti di material agiscono su oggetti custom, in questo caso MenuNode e FlatNode
    // Hanno quindi bisogno di sapere come ricavare il livello e se il nodo ha dei figli. Quindi richiedono in 
    // input le funzioni necessarie per ricavare tali informazioni a partire dagli oggetti custom
    this.treeControl = new FlatTreeControl<FlatNode>(
      (el: FlatNode) => el.level,             //vuole in input l'implementazione della funzione per ricavare il livello
      (el: FlatNode) => el.hasChildren        //vuole in input l'implementazione della funzione per sapere se il nodo ha figli
    );
    this.treeFlattener = new MatTreeFlattener<MenuNode, FlatNode>(
      this.transformer, 
      (el: FlatNode) => el.level,             //vuole in input l'implementazione della funzione per ricavare il livello
      (el: FlatNode) => el.hasChildren,       //vuole in input l'implementazione della funzione per sapere se il nodo ha figli
      (el: MenuNode): MenuNode[] => el.children //vuole in input l'implementazione della funzione per ottenere i figli del nodo
    );
    this.dataSource = new MatTreeFlatDataSource<MenuNode, FlatNode>(
      this.treeControl, 
      this.treeFlattener
    );

    this.dataSource.data = buildSelectableOptions(this.routingDataService.navigationTree, null, this._injector.get(SecurityDataService).userProfile).selectableOptions
    this.treeControl.expandAll();//TODO: fatto qui in questo modo non ha senso
  }

  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  private flatNodeToSelectableOptionMap = new Map<FlatNode, MenuNode>();
  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  private selectableOptionToFlatNodeMap = new Map<MenuNode, FlatNode>();
  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  transformer = (node: MenuNode, level: number): FlatNode => {
    const existingNode: FlatNode = this.selectableOptionToFlatNodeMap.get(node);
    const flatNode = existingNode && existingNode.id === node.id
        ? existingNode
        : new FlatNode();
    flatNode.id = node.id;
    flatNode.label = node.label;
    flatNode.level = level;
    flatNode.icon = node.icon;
    flatNode.hidden = node.hidden || !node.showInPrivateMenu;
    flatNode.disabled = node.disabled;
    flatNode.hasChildren = node.children && node.children.some(el=>el.showInPrivateMenu)
    this.flatNodeToSelectableOptionMap.set(flatNode, node);
    this.selectableOptionToFlatNodeMap.set(node, flatNode);

    return flatNode;
  }

  /**
   * funzione usata dalla direttiva
   * <pre>
   *  <code>
   *    *matTreeNodeDef when:
   *  </code>
   * </pre>
   */
  hasChild = (_: number, _nodeData: FlatNode) => _nodeData.hasChildren;

  menuClick = (menuFlatNode: FlatNode) => {
    if(!menuFlatNode.hasChildren){
      const menuNode = this.flatNodeToSelectableOptionMap.get(menuFlatNode)
      this._injector.get(Router).navigate([menuNode.url])
      if(this.isXxxs)
        this._injector.get(CanvasLayoutDataService).closeSidenav1()
    }
  }
}
